import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '../user/authentication.service';
import { User } from '../user/user';

@Component({
    selector: 'matrix-tools-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./portal.component.scss'],
    standalone: false
})
export class PortalComponent implements OnInit {
  @Input() public IsMatrixToolsDashboard: boolean;
  public user: User;

  constructor(private auth: AuthenticationService) {
  }

  ngOnInit() {
    this.user = this.auth.getCurrentUser();
    if (this.IsMatrixToolsDashboard) {
      console.log('%cMatrix Tools, LLC ~ Digital Marketing Dashboard', 'background-color: #0079a8; color: #000; font-weight: bold; padding: 5px; border-radius: 5px');
      console.log('%cRedpill', 'background-color: #f00; color: #000; font-weight: bold; padding: 5px; border-radius: 5px', this.user);
    }
  }
}
